import { Text, Button } from '@ui-component-library';

import { SELL_TIMBER_EXTRA_SPECIES } from '../helpers/sellTimberShared';

export function sectionsUseExtraSpecies(sections) {
  return SELL_TIMBER_EXTRA_SPECIES.some(({ key }) =>
    (sections ?? []).some(
      (row) => row[key] !== '' && row[key] != null && !Number.isNaN(Number(row[key]))
    )
  );
}

function FieldRow({ label, value }) {
  return (
    <div className="flex flex-row justify-between gap-3 border-b border-charcoal-100 py-2 last:border-b-0">
      <Text variant="text-sm/leading-normal/medium" className="shrink-0 text-charcoal-600">
        {label}
      </Text>
      <Text variant="text-sm/leading-normal/normal" className="min-w-0 text-right text-charcoal-900">
        {value}
      </Text>
    </div>
  );
}

/**
 * Desktop: wide table (md+). Mobile: stacked cards — no horizontal scroll.
 */
export default function SellTimberVirkesResponsiveTable({
  rows,
  showExtraCols,
  formatHa,
  formatVolumeM3fub,
  pct,
  emptyMessage,
  onEditRow,
  onDeleteRow
}) {
  const editable = Boolean(onEditRow && onDeleteRow);

  if (!rows.length) {
    return (
      <Text variant="text-sm/leading-normal/normal" className="text-charcoal-600">
        {emptyMessage}
      </Text>
    );
  }

  return (
    <>
      {/* Mobile: card list */}
      <div className="flex flex-col gap-3 md:hidden">
        {rows.map((row) => (
          <div
            key={row.id}
            className="flex flex-col rounded-lg border border-charcoal-200 bg-cloud-50/80 p-4 shadow-sm"
          >
            <Text variant="text-sm/leading-normal/medium" className="mb-2 text-charcoal-900">
              Avd # {row.name}
            </Text>
            <div className="flex flex-col">
              <FieldRow label="Areal (ha)" value={formatHa(row.area)} />
              <FieldRow label="Uttag (m³fub)" value={formatVolumeM3fub(row.volumeM3fub)} />
              <FieldRow label="Tall" value={pct(row.tall)} />
              <FieldRow label="Gran" value={pct(row.gran)} />
              <FieldRow label="Löv" value={pct(row.lov)} />
              {showExtraCols
                ? SELL_TIMBER_EXTRA_SPECIES.map(({ key, label }) => (
                    <FieldRow key={key} label={label} value={pct(row[key])} />
                  ))
                : null}
            </div>
            {editable ? (
              <div className="mt-3 flex flex-wrap gap-2 border-t border-charcoal-200 pt-3">
                <Button type="button" variant="tertiary" size="small" onClick={() => onEditRow(row)}>
                  Redigera
                </Button>
                <Button type="button" variant="tertiary" size="small" onClick={() => onDeleteRow(row)}>
                  Ta bort
                </Button>
              </div>
            ) : null}
          </div>
        ))}
      </div>

      {/* Desktop: table */}
      <div className="hidden w-full overflow-x-auto rounded-lg border border-charcoal-200 md:block">
        <table className="w-full min-w-[640px] border-collapse text-left text-sm">
          <thead>
            <tr className="border-b border-charcoal-200 bg-cloud-200">
              <th className="px-3 py-2 font-medium">Avd #</th>
              <th className="px-3 py-2 font-medium">Areal (ha)</th>
              <th className="px-3 py-2 font-medium">Uttag (m³fub)</th>
              <th className="px-3 py-2 font-medium">Tall</th>
              <th className="px-3 py-2 font-medium">Gran</th>
              <th className="px-3 py-2 font-medium">Löv</th>
              {showExtraCols
                ? SELL_TIMBER_EXTRA_SPECIES.map(({ key, label }) => (
                    <th key={key} className="px-3 py-2 font-medium">
                      {label}
                    </th>
                  ))
                : null}
              {editable ? <th className="px-3 py-2 font-medium" /> : null}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id} className="border-b border-charcoal-100">
                <td className="px-3 py-2">{row.name}</td>
                <td className="px-3 py-2">{formatHa(row.area)}</td>
                <td className="px-3 py-2">{formatVolumeM3fub(row.volumeM3fub)}</td>
                <td className="px-3 py-2">{pct(row.tall)}</td>
                <td className="px-3 py-2">{pct(row.gran)}</td>
                <td className="px-3 py-2">{pct(row.lov)}</td>
                {showExtraCols
                  ? SELL_TIMBER_EXTRA_SPECIES.map(({ key }) => (
                      <td key={key} className="px-3 py-2">
                        {pct(row[key])}
                      </td>
                    ))
                  : null}
                {editable ? (
                  <td className="px-3 py-2 whitespace-nowrap">
                    <Button
                      type="button"
                      variant="tertiary"
                      size="small"
                      className="me-2"
                      onClick={() => onEditRow(row)}
                    >
                      Redigera
                    </Button>
                    <Button
                      type="button"
                      variant="tertiary"
                      size="small"
                      onClick={() => onDeleteRow(row)}
                    >
                      Ta bort
                    </Button>
                  </td>
                ) : null}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
